import * as React from 'react'
import { connect } from 'react-redux'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardChip from './CardChip'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import { getBusinessLineItem, downloadResource } from '../lib/helpers'
import PhoneIcon from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'
const styles = (theme: any) => {
  return {
    chip: {
      color: '#fff',
      margin: '10px',
      fontWeight: 400
    },
    cardContent: {
      paddingBottom: '0px',
      fontWeight: 300,
      color: 'grey',
      display: 'flex',
      justifyContent: 'space-around',
      fontSize: '15px'
    },
    cardAction: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    button: {
      color: '#0093B2',
      position: 'absolute' as 'absolute',
      bottom: '0px',
      right: '0px'
    },
    bgButton: {
      position: 'absolute' as 'absolute',
      bottom: 0,
      right: 0,
      color: '#fff'
    }
  }
}

interface IProps {
  item: any
  classes: any
  factoidSelections: number[]
  onSelect?: (id: number, businessLineId: number) => void
  onRemove?: (id: number, businessLineId: number) => void
  hideAdd?: boolean
  businessLines: any[]
  landingPage?: boolean
}

class DoubleCard extends React.Component<IProps, {} > {

  public render() {
    const { item, classes, businessLines, landingPage } = this.props
    // MUI styles
    const classStyles = classes
    const { acf } = item
    const { left_column, right_column } = acf.factoid_content[0]

    const height = acf.factoid_height === 'Single' ? '320px' : '640px'
    const factoidType = acf.type.name
    // Associated BL
    const businessLine = getBusinessLineItem(item, businessLines)
    const extendedContent = acf.external_link && landingPage ? acf.external_link : false
    
    // @ts-ignore
    const currentlySelected = this.props.factoidSelections.includes(item.id)
      ? true
      : false

    const buttonLabel = this.props.hideAdd
      ? ''
      : currentlySelected
        ? 'Remove'
        : 'Add'

    const handleButtonClick = () => {
      if (currentlySelected) {
        if (this.props.onRemove) {
          this.props.onRemove(item.id, businessLine.id)
        }
      } else {
        if (this.props.onSelect) {
          this.props.onSelect(item.id, businessLine.id)
        }
      }
    }

    const personType = (): React.ReactNode => {
      // const { external_link } = acf
      let contact = acf.features ? acf.features.filter((f:any) => f.acf_fc_layout === "contact_information") : null;
      contact = contact !== null ? contact[0] : false;
      return (
        <PersonOuter style={{minHeight: height, position: 'relative'}}>
          <Card style={{minHeight: height}}>
            <div style={{ position: 'absolute', right: '0%' }}><CardChip factoid={this.props.item} /></div>
            <CardContent className={classStyles.cardContent} style={{
              padding: 0,
              minHeight: 320
            }}>
            {
              contact && (
                <ContactIcons>
                  <a href={`mailto:${contact.email_address}`} title="email"><EmailIcon color="primary" /></a>
                  <a href={`tel:${contact.phone_number}`} title="call"><PhoneIcon color="primary" /></a>
                </ContactIcons>
              )
            }
            
              <div style={{
                backgroundImage: `url(${acf.person_photo})`,
                width: '50%',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }} dangerouslySetInnerHTML={{ __html: left_column }} />
              <div
                style={{
                  width: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  padding: 20
                }}
                dangerouslySetInnerHTML={{ __html: right_column }}
              />
              {!this.props.hideAdd && (
                <Button
                  size="small"
                  className={classStyles.button}
                  onClick={handleButtonClick}
                >
                  {buttonLabel}
                </Button>
              )}
            </CardContent>
          </Card>
        </PersonOuter>
      )
    }

    const withBackground = (): React.ReactNode => {
      const { url } = acf.factoid_background_image
      return (
        <Card
          style={{
            backgroundImage: `url(${url})`,
            backgroundSize: 'cover',
            minHeight: height,
            position: 'relative'
          }}
        >
          <CardChip factoid={this.props.item} />
            <CardContent className={classStyles.cardContent}>
              <div dangerouslySetInnerHTML={{ __html: left_column }} />
              <div
                dangerouslySetInnerHTML={{ __html: right_column }}
     
              />
            </CardContent>
  
          {!this.props.hideAdd && !extendedContent && (
            <Button
              size="small"
              className={classStyles.bgButton}
              onClick={handleButtonClick}
            >
              {buttonLabel}
            </Button>
          )}
          {extendedContent ? (
            <Button
              size="small"
              className={classStyles.button}
              onClick={() => downloadResource(extendedContent)}
            >
            <a href={extendedContent} download={true} target="_blank">Learn more</a>
            </Button>
          ) : null}
        </Card>
      )
    }

    const withoutBackground = (): React.ReactNode => {
      return (
        <Card style={{minHeight: height}}>
          <CardChip factoid={this.props.item} />
            <CardContent className={classStyles.cardContent}>
            <div dangerouslySetInnerHTML={{ __html: left_column }} />
              <div
                dangerouslySetInnerHTML={{ __html: right_column }}
   
              />
              {!this.props.hideAdd && !extendedContent && (
                <Button
                  size="small"
                  className={classStyles.button}
                  onClick={handleButtonClick}
                >
                  {buttonLabel}
                </Button>
              )}
            </CardContent>
            {extendedContent ? (
            <Button
              size="small"
              className={classStyles.button}
              onClick={() => downloadResource(extendedContent)}
            >
            <a href={extendedContent} download={true} target="_blank">Learn more</a>
            </Button>
          ) : null}
        </Card>
      )
    }

    return (
      <Outer
      >
        {factoidType === 'Person'
          ? personType()
          : acf.factoid_background_image !== false
            ? withBackground()
            : withoutBackground()
            }
      </Outer>
    )
  }
}

export default withStyles(styles)(
  connect(
    (state: any) => ({
      factoidSelections: state.views.new.selections.factoids,
      businessLines: state.data.businessLines
    }),
    null
  )(DoubleCard)
)

const Outer = styled.div`
  position: relative;
  img {
    width: 150px;
    height: 150px;
    margin-right: 10px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: 500;
    font-size: 20px;
  }
`

const PersonOuter = styled.div`
  .person-request-call {
    display: block;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    color: #0093b2;
    text-decoration: underline;
    padding: 10px;
  }
`

const ContactIcons = styled.div`
  position: absolute;
  left: calc(50% + 20px);
  bottom: 20px;

  a{
    padding-left: 10px;
  }
`


// WEBPACK FOOTER //
// ./src/shared/DoubleCard.tsx